import React from "react";
import { withFormsy } from "formsy-react";
import { FormGroup, FormFeedback, Label } from "reactstrap";
import AsyncSelect from "react-select/lib/Async";

export class AsyncSelectComponent extends React.Component {
    state = {
        selectedOption: null,
    };

    changeValue = (selectedOption) => {
      
        if (this.props.onChange) {
            if (this.props.id >= 0) {
                this.props.onChange(selectedOption, this.props.id);
            } else {
                //check if it is updating for meal plan
                if (this.props.day >= 0) {
                   
                    this.props.onChange(selectedOption, this.props.day, this.props.mealTypeCode);
                } else {
                    this.props.onChange(selectedOption);
                }
            }
        }
        this.setState({ selectedOption });
        this.props.setValue(selectedOption && (selectedOption.length || !Array.isArray(selectedOption)) ? selectedOption : null);
        //will setup and condition to perform only for meal plans modulus only.
        if (this.props.mealModulus) {
            this.props.addFoodItemToArry(selectedOption, this.props.name);
        }
    };

    render() {
        const errorMessage = this.props.getErrorMessage();
        const { loadOptions, validating, valueKey, labelKey, disabled, showRequired, showError, getValue, name, title, isPristine, defaultOptions, onChange, cacheOptions, isRequired, hasValue, isClearable, isMulti, required } = this.props;
        const hasError = !isPristine() && (showError() || (isRequired() && !hasValue()));
        const { selectedOption } = this.state;
        return (
            <FormGroup>
                <Label className={isRequired() ? "required" : ""} htmlFor={name}>
                    {title}
                </Label>
                <small style={{ color: "blue" }}>(Enter minimum of 3 characters)</small>
                <AsyncSelect
                    isMulti={isMulti}
                    cacheOptions={cacheOptions}
                    loadOptions={loadOptions}
                    value={getValue() || selectedOption}
                    defaultOptions={defaultOptions}
                    className={hasError ? "is-invalid" : ""}
                    isDisabled={validating ? true : false || disabled}
                    name={name}
                    isClearable={isClearable}
                    onChange={onChange || this.changeValue}
                    getOptionLabel={(option) => option[labelKey]}
                    getOptionValue={(option) => option[valueKey]}
                    required={required}
                />
                {hasError ? <FormFeedback>{errorMessage}</FormFeedback> : ""}
                {showRequired() ? <FormFeedback>Required</FormFeedback> : ""}
            </FormGroup>
        );
    }
}

const FormSelect = withFormsy(AsyncSelectComponent);

export { FormSelect as AsyncSelect };
